import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { PerspectiveHero } from "@/components/control-tower/PerspectiveHero";
import { IndoorConditionsSection } from "@/components/control-tower/perspectives/IndoorConditionsSection";

export const Route = createFileRoute("/indoor-conditions")({
  component: IndoorConditionsPage,
});

// Sisäilmaolosuhteet — zone-first indoor conditions lens (story #960). Additive to Datan
// laatu / Kaksonen / Analyysi; filters by the zone axis (source_type = zone), owns no
// Finding category. Building scope renders the live zone panel directly, no
// Yhteenveto/Havainnot/Tapahtumaloki topic tabs; Havainnot reached
// on the zone axis via the Toiminto.
function IndoorConditionsPage() {
  return (
    <Shell
      title="Sisäilmaolosuhteet"
      subtitle="Vyöhykkeiden olosuhteet · elävä tila ja havainnot"
    >
      <div className="space-y-6">
        <PerspectiveHero perspectiveId="indoor-conditions" />
        <IndoorConditionsSection />
      </div>
    </Shell>
  );
}
